// reducers/listReducer.js
import { FETCH_DOCUMENTATION_SUCCESS, FETCH_DOCUMENTATION_FAILURE,REDIRECT_TO_LOGIN } from './actionsTypes';

const initialState = {
  documentationData: [],
  error: null,
  redirectToLoginPage: false,
};

const DocumentationReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DOCUMENTATION_SUCCESS:
      return {
        ...state,
        DocumentationData: action.payload.documentationData,
        error: null,
      };
    case FETCH_DOCUMENTATION_FAILURE:
      return {
        ...state,
        documentationData: [],
        error: action.payload.error,
      };
    case REDIRECT_TO_LOGIN:
        return {
            ...state,
            redirectToLoginPage: true,
        };
    default:
      return state;
  }
};

export default DocumentationReducer;
